/**
 * Translation keys for the shared override-details panel.
 * Section headings come from each host's status-pill key (not listed here);
 * by-lines / justification use shared `override.panel.*` keys;
 * tag labels stay feature-scoped where callers already registered them.
 */
export interface IOverrideDetailsKeys {
    /** Person actor: `Utført av {{name}}` / `Performed by {{name}}`. */
    by: string;
    /** Application actor (literal overriddenby/deletedby `System`). */
    bySystem: string;
    justificationEmpty: string;
    tagId: string;
    tagValue: string;
    tagSyncImportFileId: string;
    btnEdit: string;
    btnCancel: string;
    btnSave: string;
}

/** Shared panel chrome — one CMS registration for all override hosts. */
const SHARED_PANEL_KEYS = {
    by: 'override.panel.by',
    bySystem: 'override.panel.by.system',
    justificationEmpty: 'override.panel.justification.empty',
} as const;

export const MEMBERSHIP_OVERRIDE_DETAILS_KEYS: IOverrideDetailsKeys = {
    ...SHARED_PANEL_KEYS,
    tagId: 'user.membership.override.tag.id',
    tagValue: 'user.membership.override.tag.value',
    tagSyncImportFileId: 'user.membership.override.tag.syncronizedimportfileid',
    btnEdit: 'edit',
    btnCancel: 'cancel',
    btnSave: 'save',
};

export const PERMISSIONS_OVERRIDE_DETAILS_KEYS: IOverrideDetailsKeys = {
    ...SHARED_PANEL_KEYS,
    tagId: 'user.permissions.override.tag.id',
    tagValue: 'user.permissions.override.tag.value',
    tagSyncImportFileId: 'user.permissions.override.tag.syncronizedimportfileid',
    btnEdit: 'user.permissions.btn.edit',
    btnCancel: 'user.permissions.btn.cancel',
    btnSave: 'user.permissions.btn.save',
};

export const GROUP_MEMBERS_OVERRIDE_DETAILS_KEYS: IOverrideDetailsKeys = {
    ...SHARED_PANEL_KEYS,
    tagId: 'group.members.override.tag.id',
    tagValue: 'group.members.override.tag.value',
    tagSyncImportFileId: 'group.members.override.tag.syncronizedimportfileid',
    btnEdit: 'edit',
    btnCancel: 'cancel',
    btnSave: 'save',
};

export const SOURCE_DATA_OVERRIDE_DETAILS_KEYS: IOverrideDetailsKeys = {
    ...SHARED_PANEL_KEYS,
    tagId: 'view.objectdetail.sourcedata.override.tag.id',
    tagValue: 'view.objectdetail.sourcedata.override.tag.value',
    tagSyncImportFileId: 'view.objectdetail.sourcedata.override.tag.syncronizedimportfileid',
    btnEdit: 'edit',
    btnCancel: 'cancel',
    btnSave: 'save',
};
